// Shared Opportunity domain constants — single source of truth so the
// create/edit form (OpportunityFormModal) and the Kanban/List filter
// (OpportunityManagement) can never drift apart on labels or values.
//
// `value` must match the backend enum stored on Opportunity.lines_of_business
// (see backend/models.py); `label` is the human-facing display string.
export const LINES_OF_BUSINESS = [
  { value: 'professional_services', label: 'Professional Services' },
  { value: 'field_services', label: 'Field Services' },
  { value: 'referral_mrr', label: 'Referral MRR' },
  { value: 'wholesale_mrr', label: 'Wholesale MRR' },
];
